import { Chip, ChipProps } from "@mui/material";
import { DbMarkerSeverity } from "../../Core/Api/Types/db-marker-severity";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

export type renderStatusMarkerProps = {
  status: DbMarkerSeverity;
};

const StatusMarkerRender: React.FC<renderStatusMarkerProps> = (props) => {
  const statusChip: { color: ChipProps["color"]; text: string; icon: ChipProps["icon"] } = {
    color: "primary",
    text: "",
    icon: undefined,
  };
  switch (props.status) {
    case DbMarkerSeverity.ERROR:
      statusChip.color = "error";
      statusChip.text = "Critical";
      statusChip.icon = <ErrorOutlineOutlinedIcon />;
      break;
    case DbMarkerSeverity.WARNING:
      statusChip.color = "warning";
      statusChip.text = "Warning";
      break;
    case DbMarkerSeverity.INFO:
      statusChip.color = "info";
      statusChip.text = "Info";
      break;
  }

  return <Chip label={statusChip.text} color={statusChip.color} size="small" icon={statusChip.icon} />;
};
export default StatusMarkerRender;
